export function renderFooter() {
  return `
    <footer class="site-footer">
      <div class="footer-brand">
        <p>womyn.network</p>
        <span>&copy; 2026 womyn.network. A social network, for women.</span>
      </div>

      <div class="footer-link-groups">
        <div class="footer-group">
          <h2>Company</h2>
          <a href="/#vision" data-route>Vision</a>
          <a href="/#pillars" data-route>Pillars</a>
        </div>
        <div class="footer-group">
          <h2>Legal</h2>
          <!-- Privacy Policy -->
          <!-- Community Guidelines -->
          <a href="/contact" data-route>Enquiries</a>
          <a href="/terms" data-route>Beta Terms</a>
        </div>
        <div class="footer-group">
          <h2>Support</h2>
          <a href="/contact" data-route>Contact Us</a>
          <a href="/#faq" data-route>FAQ</a>
        </div>
      </div>
    </footer>
  `;
}
